import React from 'react';
import DownshiftContext from '../context';
export function useDownshiftContext() {
  return React.useContext(DownshiftContext);
}